// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"AuthProvider_spinnerContainer__ExJis"};